import { ProjectHeader } from './ProjectHeader';
import ProjectContext from './ProjectContext';
import { JobsList } from './JobsList';
import React from 'react';

export const ProjectScreen: React.FC = () => {
  const [selectValue, setSelectValue] = React.useState(-1);
  const [searchTerm, setSearchTerm] = React.useState('');
  return (
    <ProjectContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        selectValue,
        setSelectValue,
      }}
    >
      <ProjectHeader />
      <JobsList />
    </ProjectContext.Provider>
  );
};
